import {all, call, put, select, takeLatest} from 'redux-saga/effects';
import request from 'utils/request';
import {makeSelectUserToken} from 'reducers/selectors/userSelectors';

import {
  CREATE_FOLDER,
  createFolderFailed,
  createFolderSuccess,
  FETCH_FOLDER,
  FETCH_FOLDERS,
  fetchFolderFailed,
  fetchFoldersFailed,
  fetchFoldersSuccess,
  fetchFolderSuccess,
  UPDATE_FOLDER,
  updateFolderFailed,
  updateFolderSuccess,
} from 'actions/folderActions';

const requestUrl = `pages`;

function* fetchFolders() {
  const authToken = yield select(makeSelectUserToken());
  try {
    const response = yield call(request, requestUrl, authToken, {});
    yield put(fetchFoldersSuccess(response.pageFolders));
  } catch (err) {
    yield put(fetchFoldersFailed(err));
  }
}

function* fetchFolder(action) {
  // const authToken = yield select(makeSelectUserToken());
  const url = action.subdomain
    ? `${requestUrl}/filterbyDomain/${action.subdomain}`
    : `${requestUrl}/${action.pageId}`;

  try {
    const response = yield call(request, url, undefined, {});
    yield put(fetchFolderSuccess(response.data));
  } catch (err) {
    yield put(fetchFolderFailed(err));
  }
}

function* createFolder(action) {
  const authToken = yield select(makeSelectUserToken());

  const requestOptions = {
    method: 'POST',
    body: JSON.stringify(action.details),
  };

  try {
    const response = yield call(request, requestUrl, authToken, requestOptions);

    yield put(createFolderSuccess(response.pageFolder));
  } catch (err) {
    yield put(createFolderFailed(err));
  }
}

function* updateFolder(action) {
  const authToken = yield select(makeSelectUserToken());
  const requestOptions = {
    method: 'PUT',
    body: JSON.stringify(action.details),
  };

  try {
    const response = yield call(
      request,
      `${requestUrl}/${action.pageId}`,
      authToken,
      requestOptions
    );
    yield put(updateFolderSuccess(response.pageFolder));
  } catch (err) {
    yield put(updateFolderFailed(err));
  }
}

export default function* signinSagas() {
  yield all([
    takeLatest(FETCH_FOLDERS, fetchFolders),
    takeLatest(CREATE_FOLDER, createFolder),
    takeLatest(UPDATE_FOLDER, updateFolder),
    takeLatest(FETCH_FOLDER, fetchFolder),
  ]);
}
